
import { defineComponent } from 'vue'
import { showModal } from '@/plugins/vue-final-modal'
import { translate } from '@/core/services/translation-service'
import { trackReadBeforeFirstVisit } from '@/core/services/tracking-service'

export default defineComponent({
  setup() {
    function readMore() {
      showModal('ModalFirstVisit')
      trackReadBeforeFirstVisit()
    }

    return {
      readMore,
      showModal,
      translate
    }
  }
})
